import { sanitizeStoryHtml } from './fundRichEditor.js';
import { renderPollHtml } from './fundPolls.js';

export function normalizeUpdateEntry(raw) {
    if (!raw) return null;
    if (raw.title || raw.bodyHtml) {
        return {
            id: raw.id || `upd-${Date.now()}`,
            title: raw.title || 'Update',
            bodyHtml: raw.bodyHtml || '',
            imageUrl: raw.imageUrl || '',
            createdAt: raw.createdAt || raw.date || new Date().toISOString(),
            date: raw.date || formatUpdateDate(raw.createdAt),
            poll: raw.poll || null,
        };
    }
    return {
        id: raw.id || `upd-${Date.now()}`,
        title: 'Update',
        bodyHtml: raw.text || '',
        imageUrl: '',
        createdAt: new Date().toISOString(),
        date: raw.date || formatUpdateDate(),
    };
}

function formatUpdateDate(iso) {
    try {
        return new Date(iso || Date.now()).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    } catch {
        return '';
    }
}

export function sortUpdates(updates = []) {
    return [...updates]
        .map(normalizeUpdateEntry)
        .filter(Boolean)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
}

export function createUpdatePayload({ title, bodyHtml, imageUrl = '' }) {
    const now = new Date().toISOString();
    return {
        id: `upd-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
        title: String(title || '').trim() || 'Campaign update',
        bodyHtml: sanitizeStoryHtml(bodyHtml || ''),
        imageUrl: imageUrl || '',
        createdAt: now,
        date: formatUpdateDate(now),
    };
}

/** Emails of backers with completed pledges (from comment records). */
export function getBackerEmailsFromProject(project) {
    const emails = new Set();
    (project.comments || []).forEach((c) => {
        if (c.donorEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c.donorEmail)) {
            emails.add(c.donorEmail.toLowerCase());
        }
    });
    return [...emails];
}

export function renderUpdatesListHtml(updates, fund, campaignId, voterEmail = '') {
    const sorted = sortUpdates(updates);
    if (!sorted.length) {
        return `<p class="fg-fund-empty-sub">${fund.tr('noUpdatesYet')}</p>`;
    }
    return sorted.map((u) => `
        <article class="fg-fund-update-card">
            <time class="fg-fund-update-card__date">${u.date}</time>
            <h4 class="fg-fund-update-card__title">${escapeHtml(u.title)}</h4>
            <div class="fg-fund-rich-body">${u.bodyHtml}</div>
            ${u.imageUrl ? `<img class="fg-fund-update-card__img" src="${u.imageUrl}" alt="">` : ''}
            ${u.poll ? renderPollHtml(u.poll, campaignId, u.id, fund, voterEmail) : ''}
        </article>`).join('');
}

function escapeHtml(s) {
    return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
